<template>
  <div>
      <i :class="`fa  font_lg  ${realIcon.iconName}  ${realIcon.colorName}`"></i>
  </div>
</template>
<script>
export default {
  data() {
    return {
        tipContent:''
    };
  },
  mounted() {},
  computed: {
    realIcon() {
      let defaultIcon = this.params.color(this.params.data);
      return defaultIcon;
    }
  }
};
</script>
